import styled, { css } from 'styled-components';
import { toRem } from '@marriott/shared/mi-helper-utils';
import { baseVariables } from '../../styles';

const { mediaQuery } = baseVariables;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;

  @media ${mediaQuery.md} {
    height: 100%;
  }
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .swiper-slide:not(.swiper-slide-active) {
    visibility: hidden;
  }
`;

export const SlideContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${mediaQuery.md} {
    height: 100%;

    picture {
      height: 100%;
    }
  }

  img {
    width: 100%;

    @media ${mediaQuery.md} {
      object-fit: cover;
      object-position: center center;
      height: 100%;
    }
  }
`;

export const ArrowsWrapper = styled.div<{ $revealOnHover: boolean }>`
  position: absolute;
  inset-block-start: 50%;
  inset-inline: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 1rem;
  pointer-events: none;
  z-index: 10;

  ${({ $revealOnHover }) =>
    $revealOnHover &&
    css`
      opacity: 0;
      transition: opacity 200ms ease-out;

      ${Wrapper}:hover &,
      ${Wrapper}:focus-within & {
        opacity: 1;
      }
    `}
`;

export const ArrowLeft = styled.div`
  pointer-events: auto;
`;

export const ArrowRight = styled.div`
  pointer-events: auto;
`;

export const ControlsWrapper = styled.div`
  position: absolute;
  inset-block-end: 1rem;
  inset-inline-start: 50%;
  transform: translateX(-50%);
  z-index: 10;
`;

// Bottom-anchored band that hosts AScrimGradient for the Numbers counter,
// mirroring the logo-variant scrim this ticket matches. AScrimGradient fills
// this band as its safe zone and feathers its top edge up into the image; the
// counter overlays it from ControlsWrapper. The carousel is already in an
// inverse context (root Wrapper), so the scrim tokens resolve by inheritance.
export const ScrimWrapper = styled.div`
  position: absolute;
  inset-inline: 0;
  inset-block-end: 0;
  height: ${toRem(65)};
  z-index: 2;
  pointer-events: none;
`;
